import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAiAgentsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-ai-agents',
	path: '/jira/servicedesk/projects/:projectKey/settings/ai-agents',
	exact: true,
};
